<p-toast role="status" aria-live="polite" aria-atomic="true" />

@if (isLoading()) {
  <div class="flex flex-column align-items-center justify-content-center w-full p-8">
    <p-progress-spinner strokeWidth="3" ariaLabel="Caricamento tariffe in corso" />
    <p class="mt-3 text-600">Caricamento tariffe...</p>
  </div>
}

@if (!isLoading() && paymentRates().length > 0) {
  <form [formGroup]="form" class="p-fluid">
    <section class="surface-0 border-round p-5 mb-4 shadow-1">
      <div class="grid">
        @for (rate of paymentRates(); track rate.fieldId; let i = $index; let last = $last) {
          <div [class]="isOtherSelected(rate.fieldId) ? 'field col-12 md:col-6' : 'field col-12'">
            <label [for]="'rate-' + rate.fieldId" class="font-semibold block mb-2">
              <span class="text-500 mr-2">{{ i + 1 }}.</span>
              {{ rate.paymentRateDescription }}
              @if (rate.isMandatory) {
                <span class="text-red-500" aria-hidden="true">*</span>
              }
            </label>

            @if (rate.prType === 'INPUT_TEXT') {
              <input
                pInputText
                [id]="'rate-' + rate.fieldId"
                [formControlName]="rate.fieldId"
                placeholder="Inserisci valore"
                class="w-full"
                [attr.aria-required]="rate.isMandatory"
                [attr.aria-invalid]="getControl(rate.fieldId).invalid && getControl(rate.fieldId).touched"
                [attr.aria-describedby]="getControl(rate.fieldId).invalid && getControl(rate.fieldId).touched ? 'rate-error-' + rate.fieldId : null"
              />
            } @else {
              <p-select 
                [id]="'rate-' + rate.fieldId"
                [options]="rate.dropdownOptions" 
                [formControlName]="rate.fieldId"
                (onChange)="onRateValueChange(rate.fieldId)"
                optionLabel="valueDescription" 
                optionValue="valueKey"
                placeholder="Seleziona una tariffa"
                [showClear]="true"
                class="w-full"
                [attr.aria-required]="rate.isMandatory"
                [attr.aria-invalid]="getControl(rate.fieldId).invalid && getControl(rate.fieldId).touched"
                [attr.aria-describedby]="getControl(rate.fieldId).invalid && getControl(rate.fieldId).touched ? 'rate-error-' + rate.fieldId : null"
              />
            }

            @if (getControl(rate.fieldId).invalid && getControl(rate.fieldId).touched) {
              <small [id]="'rate-error-' + rate.fieldId" class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>

          @if (isOtherSelected(rate.fieldId)) {
            <div class="field col-12 md:col-6 fadein animation-duration-300">
              <label [for]="'rate-other-' + rate.fieldId" class="font-semibold block mb-2">
                Valore personalizzato
                @if (rate.isMandatory) {
                  <span class="text-red-500" aria-hidden="true">*</span>
                }
                <i
                  class="pi pi-info-circle ml-2 text-500"
                  pTooltip="Inserire il testo da visualizzare nel contratto, simbolo euro incluso."
                  tooltipPosition="top"
                  tabindex="0"
                  role="img"
                  aria-label="Informazioni sul valore personalizzato"
                ></i>
              </label>
              <input
                pInputText
                [id]="'rate-other-' + rate.fieldId"
                [formControlName]="rate.fieldId + '_OTHER'"
                type="text"
                maxlength="255"
                placeholder="es. € 250,00 per intervento"
                class="w-full"
                [attr.aria-label]="'Valore personalizzato per ' + rate.paymentRateDescription"
                [attr.aria-required]="rate.isMandatory && isOtherSelected(rate.fieldId)"
                [attr.aria-invalid]="
                  getControl(rate.fieldId + '_OTHER').invalid &&
                  getControl(rate.fieldId + '_OTHER').touched
                "
                [attr.aria-describedby]="
                  getControl(rate.fieldId + '_OTHER').invalid &&
                  getControl(rate.fieldId + '_OTHER').touched
                    ? 'rate-other-error-' + rate.fieldId
                    : null
                "
              />
              @if (
                getControl(rate.fieldId + '_OTHER').invalid &&
                getControl(rate.fieldId + '_OTHER').touched
              ) {
                <small [id]="'rate-other-error-' + rate.fieldId" class="text-red-500" role="alert">
                  @if (getControl(rate.fieldId + '_OTHER').hasError('maxlength')) {
                    Massimo 255 caratteri
                  } @else {
                    Campo obbligatorio
                  }
                </small>
              }
            </div>
          }

          @if (!last) {
            <div class="col-12 border-bottom-1 border-200 mb-3"></div>
          }
        }
      </div>

      <!-- Action buttons -->
      <div class="flex justify-content-end gap-3 mt-4 pt-4 border-top-1 border-200">
        <p-button
          label="Salva Bozza"
          icon="pi pi-save"
          [outlined]="true"
          styleClass="btn-draft"
          (onClick)="saveDraft()"
          [loading]="isSubmitting()"
          [disabled]="isSubmitting()"
          aria-label="Salva come bozza senza validazione"
          title="Salva come bozza senza validazione"
        />
        <p-button
          label="Salva e Prosegui"
          icon="pi pi-arrow-right"
          iconPos="right"
          (onClick)="save()"
          [loading]="isSubmitting()"
          [disabled]="isSubmitting()"
          title="Salva e prosegui al passo successivo"
        />
      </div>
    </section>
  </form>
}

@if (!isLoading() && paymentRates().length === 0) {
  <section class="surface-0 border-round p-5 mb-4 shadow-1">
    <div class="flex flex-column align-items-center justify-content-center p-6 text-center">
      <i class="pi pi-info-circle text-6xl text-400 mb-4" aria-hidden="true"></i>
      <h2 class="text-xl font-semibold text-700 m-0 mb-2">Nessuna tariffa configurata</h2>
      <p class="text-600 m-0">
        Non sono state trovate tariffe per questa categoria di fiduciario.
      </p>
    </div>
  </section>
}
